module.exports = __webpack_public_path__ + "img/p2.a3d8e0af.png";